import * as React from 'react';

const LazyGridScreenContainer = React.lazy(() =>
    import('../../containers/GridScreenContainer/GridScreenContainer' /* webpackChunkName: "grids" */)
);
const LazyLogScreenRouteContainer = React.lazy(() =>
    import('../../containers/LogScreenRouteContainer/LogScreenRouteContainer' /* webpackChunkName: "logs" */)
);
const LazyBannersScreenContainer = React.lazy(() =>
    import('../../containers/BannersScreenContainer/BannersScreenContainer' /* webpackChunkName:"bannersEdit" */)
);
const LazyInternalBannersScreenContainer = React.lazy(() =>
    import('../../containers/InternalBannersScreenContainer/InternalBannersScreenContainer' /* webpackChunkName:"internalBannersEdit" */)
);
const LazyDealsScreenRouteContainer = React.lazy(() =>
    import('../../containers/DealsScreenContainer/DealsScreenContainer' /* webpackChunkName:"deals" */)
);
const LazyFreelancerCardEditPageContainer = React.lazy(() =>
    import('../../containers/FreelancerCardEditPageContainer/FreelancerCardEditPageContainer' /* webpackChunkName: "freelancerCardEditPage" */)
);
const LazyFreelancerCardWrapper = React.lazy(() =>
    import('../../components/FreelancerCardWrapper/FreelancerCardWrapper' /* webpackChunkName: "freelancerCard" */)
);
const LazyFreelancerCustomersScreenContainerWrapper = React.lazy(() =>
    import('../../containers/FreelancerCustomersScreenContainerWrapper/FreelancerCustomersScreenContainerWrapper' /* webpackChunkName: "freelancerCustomers" */)
);
const LazyFreelancersListScreenContainer = React.lazy(() =>
    import('../../containers/FreelancersListScreenContainer/FreelancersListScreenContainer' /* webpackChunkName: "freelancersList" */)
);
const LazyCampaignsScreenContainer = React.lazy(() =>
    import('../../containers/CampaignsScreenContainer/CampaignsScreenContainer' /* webpackChunkName: "campaignsEdit" */)
);
const LazyGroupsScreenContainer = React.lazy(() =>
    import('../../containers/GroupsScreenContainer/GroupsScreenContainer' /* webpackChunkName: "groupsEdit" */)
);
const LazyMobileAppRouteContainer = React.lazy(() =>
    import('../../containers/MobileAppRouteContainer/MobileAppRouteContainer' /* webpackChunkName: "mobileApp" */)
);
const LazyMobileAppsListRouteContainer = React.lazy(() =>
    import('../../containers/MobileAppsListRouteContainer/MobileAppsListRouteContainer' /* webpackChunkName: "mobileAppsList" */)
);
const LazyRecommendationsItemsScreenContainer = React.lazy(() =>
    import('../../containers/RecommendationsItemsScreenContainer/RecommendationsItemsScreenContainer' /* webpackChunkName: "recommendationsItems" */)
);
const LazyRecommendationsScreenContainer = React.lazy(() =>
    import('../../containers/RecommendationsScreenContainer/RecommendationsScreenContainer' /* webpackChunkName: "recommendationsScreen" */)
);
const LazyReportsClientScreenContainer = React.lazy(() =>
    import('../../containers/ReportsClientScreenContainer/ReportsClientScreenContainer' /* webpackChunkName: "reportsClient" */)
);
const LazyReportsDomainScreenContainer = React.lazy(() =>
    import('../../containers/ReportDomainsScreenContainer/ReportDomainsScreenContainer' /* webpackChunkName: "reportsDomains" */)
);
const LazyToolsScreenContainer = React.lazy(() =>
    import('../../containers/ToolsScreenContainer/ToolsScreenContainer' /* webpackChunkName: "tools" */)
);
const LazyWelcomeScreenContainer = React.lazy(() =>
    import('../../containers/WelcomeScreenContainer/WelcomeScreenContainer' /* webpackChunkName: "welcome" */)
);
const LazyMinusPhraseLibraryScreenContainer = React.lazy(() =>
    import('../../containers/MinusPhraseLibraryScreenContainer/MinusPhraseLibraryScreenContainer' /* webpackChunkName: "minusKeywordsLibraryGrid" */)
);

const LazyProductsContainer = React.lazy(() =>
    import('../../containers/ProductsContainer/ProductsContainer' /* webpackChunkName: "products" */)
);

const LazyMarketersContainer = React.lazy(() =>
    import('../../containers/MarketersContainer/MarketersContainer' /* webpackChunkName: "marketers" */)
);

const LazyMarketerCardContainer = React.lazy(() =>
    import('../../containers/MarketerCardContainer/MarketerCardContainer' /* webpackChunkName: "marketerCard" */)
);

export {
    LazyGridScreenContainer,
    LazyLogScreenRouteContainer,
    LazyBannersScreenContainer,
    LazyInternalBannersScreenContainer,
    LazyDealsScreenRouteContainer,
    LazyFreelancerCardEditPageContainer,
    LazyFreelancerCardWrapper,
    LazyFreelancerCustomersScreenContainerWrapper,
    LazyFreelancersListScreenContainer,
    LazyCampaignsScreenContainer,
    LazyGroupsScreenContainer,
    LazyMobileAppRouteContainer,
    LazyMobileAppsListRouteContainer,
    LazyRecommendationsItemsScreenContainer,
    LazyRecommendationsScreenContainer,
    LazyReportsClientScreenContainer,
    LazyReportsDomainScreenContainer,
    LazyToolsScreenContainer,
    LazyWelcomeScreenContainer,
    LazyMinusPhraseLibraryScreenContainer,
    LazyProductsContainer,
    LazyMarketersContainer,
    LazyMarketerCardContainer
};
